import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { FeatureFlagStoreSelectors, RootStoreState } from '../root-store';
import { FeatureFlagKey } from '@surface-elements/shared/shared-util';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagGuard {
  private store = inject<Store<RootStoreState.State>>(Store);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const flagKey = route.data['featureFlag'] as FeatureFlagKey;

    if (!flagKey) return false;

    let enabled = false;

    this.store
      .select(FeatureFlagStoreSelectors.selectFlag(flagKey))
      .subscribe(value => {
        enabled = value;
      });

    if (!enabled) {
      this.router.navigateByUrl('/jobs');
    }

    return enabled;
  }
}
